import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import "swiper/css";
import "swiper/css/pagination";

const CATEGORIES = [
  { title: "Arts",               image: "/assets/images/categories/arts.webp" },
  { title: "Dance",              image: "/assets/images/categories/dance.webp" },
  { title: "Sports",             image: "/assets/images/categories/sports.webp" },
  { title: "Yoga",               image: "/assets/images/categories/yoga.webp" },
  { title: "Summer Camp",        image: "/assets/images/categories/summer-camp.webp" },
  { title: "Academics",          image: "/assets/images/categories/academics.webp" },
  { title: "Child Care",         image: "/assets/images/categories/childcare.webp" },
  { title: "Coding",             image: "/assets/images/categories/coding.webp" },
  { title: "Music",              image: "/assets/images/categories/music.webp" },
  { title: "STEAM / STEM",       image: "/assets/images/categories/steam.webp" },
  { title: "Birthdays",          image: "/assets/images/categories/birthdays.webp" },
  { title: "Science",            image: "/assets/images/categories/science.webp" },
  { title: "Baby / Infants",     image: "/assets/images/categories/baby.webp" },
  { title: "Language / Culture", image: "/assets/images/categories/language-culture.webp" },
  { title: "Swimming",           image: "/assets/images/categories/swimming.webp" },
  { title: "Counselling",        image: "/assets/images/categories/counselling.webp" },
  { title: "Teen Programs",      image: "/assets/images/categories/teen-programs.webp" },
  { title: "Others",             image: "/assets/images/categories/others.webp" },
];

export default function ActivityCategories({ showMobile = false, mobileOnly = false }) {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const scrollByCard = (dir) => {
    scrollRef.current?.scrollBy({ left: dir * 284, behavior: "smooth" });
  };

  const goToCategory = (title) => {
    navigate(`/activities?category=${encodeURIComponent(title)}`);
  };

  const swiper = (
    <Swiper modules={[Pagination]} spaceBetween={16} slidesPerView={1} pagination={{ clickable: true }}>
      {CATEGORIES.map((cat) => (
        <SwiperSlide key={cat.title}>
          <div
            className="activitycats-cards-mobile"
            style={{ cursor: "pointer" }}
            onClick={() => goToCategory(cat.title)}
          >
            <div className="event-image" style={{ backgroundImage: `url('${cat.image}')` }} />
            <div className="event-content glass">
              <h3 className="event-title">{cat.title}</h3>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );

  if (mobileOnly) {
    return (
      <div className="heading-section-mobile">
        <h2 className="section-title-mobile">Activity Categories</h2>
        <br />
        {swiper}
      </div>
    );
  }

  return (
    <section className="search-section">
      <h2 className="search-title">Activity Categories</h2>

      {/* Desktop horizontal scroll */}
      <div className="activity-cats-desktop activity-cats-scroll-wrap">
        <button
          type="button"
          className="activity-cats-arrow left"
          aria-label="Scroll left"
          onClick={() => scrollByCard(-1)}
        >
          <FiArrowLeft />
        </button>

        <div className="activity-cats-scroll" ref={scrollRef} style={{ padding: "10px 30px" }}>
          {CATEGORIES.map((cat) => (
            <div
              className="event-cards"
              key={cat.title}
              style={{ cursor: "pointer" }}
              onClick={() => goToCategory(cat.title)}
            >
              <div className="event-image" style={{ backgroundImage: `url('${cat.image}')` }} />
              <div className="event-content glass">
                <h3 className="event-title">{cat.title}</h3>
              </div>
            </div>
          ))}
        </div>

        <button
          type="button"
          className="activity-cats-arrow right"
          aria-label="Scroll right"
          onClick={() => scrollByCard(1)}
        >
          <FiArrowRight />
        </button>
      </div>

      {/* Mobile swiper — only when showMobile */}
      {showMobile && (
        <div className="hp-mobile" style={{ padding: "10px 16px" }}>
          {swiper}
        </div>
      )}
    </section>
  );
}
